module.exports = __webpack_public_path__ + "placa_mov_10x_s_entr_s_juros.png?901c076ee238790ea72f19a784fb7faf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_mov_10x_s_entr_s_juros.png
// module id = 126
// module chunks = 0